const SRC = {
  light: "/brand/creatori-wordmark.png",       // two-tone (blue + black), for white surfaces
  mono: "/brand/creatori-wordmark-mono.png",   // all dark, for light/blue-gradient surfaces
  dark: "/brand/creatori-wordmark-dark.png",   // blue + near-white, for dark surfaces
  auth: "/brand/creatori-wordmark-auth.png",   // solid dark wordmark, for auth blue-gradient pages
};

export function Logo({ className = "h-6 w-auto", variant = "light", testid = "logo" }) {
  return <img src={SRC[variant] || SRC.light} alt="Creatori" className={className} data-testid={testid} draggable="false" />;
}
